import * as Yup from 'yup'

const makeQuestionSchema = (t) =>
  Yup.object().shape({
    question: Yup.string().required(t('internal-inspections:validation.questionRequired')),
  })

const makeRoomItemSchema = (t) =>
  Yup.object().shape({
    name: Yup.string().required(t('internal-inspections:validation.objectNameRequired')),
    description: Yup.string(),
    listPosition: Yup.number(),
    questions: Yup.array().of(makeQuestionSchema(t)),
    requirePhoto: Yup.boolean(),
    requireRating: Yup.boolean(),
    requireNote: Yup.boolean(),
  })

const makeRoomSchema = (t) =>
  Yup.object().shape({
    name: Yup.string().required(t('internal-inspections:validation.locationNameRequired')),
    roomItems: Yup.array()
      .of(makeRoomItemSchema(t))
      .min(1, t('internal-inspections:validation.atLeastOneObjectRequired')),
  })

const makeValidationSchema = (t) => {
  const roomItemSchema = makeRoomItemSchema(t)
  const roomSchema = makeRoomSchema(t)

  return Yup.object().shape({
    name: Yup.string().required(t('internal-inspections:validation.inspectionNameRequired')),
    templateName: Yup.string().required(t('internal-inspections:validation.templateNameRequired')),
    description: Yup.string(),
    noteRequired: Yup.boolean(),
    photosRequired: Yup.boolean(),
    advanced: Yup.boolean(),
    guided: Yup.boolean(),
    rooms: Yup.array()
      .of(roomSchema)
      .when('advanced', {
        is: false,
        then: Yup.array(), // Allow empty array if advanced is false
        otherwise: Yup.array().min(
          1,
          t('internal-inspections:validation.atLeastOneLocationRequired'),
        ),
      })
      .when('guided', {
        is: true,
        then: Yup.array().of(
          roomSchema.shape({
            roomItems: Yup.array()
              .of(
                roomItemSchema.test(
                  'require-photo-or-condition-rating',
                  t('internal-inspections:validation.requirePhotoOrRating'),
                  function (roomItem) {
                    return roomItem.requirePhoto || roomItem.requireRating
                  },
                ),
              )
              .min(1, t('internal-inspections:validation.atLeastOneObjectRequired')),
          }),
        ),
      }),
  })
}

export default makeValidationSchema
